import React, { useState } from 'react'
import {
  Button,
  Column,
  Columns,
  Container,
  PasswordInput,
} from '@resurs/midas-react'
import { useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Page from '../../internal/Page'
import { getText } from '../../internal/TextLabels'
import styles from './ConfirmEmailChange.module.scss'
import BackToLogin from '../../internal/BackToLogin'
import { confirmEmailChange } from '../../store/actions/users-actions'

const ConfirmEmailChange = ({ onConfirmEmailChange }) => {
  const [password, setPassword] = useState(null)
  const location = useLocation()
  const query = new URLSearchParams(location.search)
  const temporaryEmailToken = query.get('token')

  return (
    <Container grid960>
      <Columns>
        <Column col4 colMd2 colSm0 />
        <Column col4 colMd8 colSm12>
          <div className={styles.confirmEmailChange}>
            <Page title={getText('confirmEmail.title')}>
              <div className={styles.inner}>
                <form onSubmit={e => e.preventDefault()}>
                  <PasswordInput
                    id="password-field"
                    label={getText('confirmEmail.password')}
                    required={getText('default.form.required')}
                    peek
                    peekLabel={getText('confirmEmail.peekLabel')}
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                  />
                  <Button
                    id="confirm-email-change-button"
                    text={getText('confirmEmail.button')}
                    type="primary"
                    fullWidth
                    form
                    onClick={() =>
                      onConfirmEmailChange(password, temporaryEmailToken)
                    }
                    disabled={!password}
                  />
                </form>
              </div>
            </Page>
          </div>
          <BackToLogin />
        </Column>
      </Columns>
    </Container>
  )
}

ConfirmEmailChange.propTypes = {
  onConfirmEmailChange: PropTypes.func.isRequired,
}

const mapDispatchToProps = dispatch => ({
  onConfirmEmailChange: (password, temporaryEmailToken) => {
    dispatch(confirmEmailChange({ password, temporaryEmailToken }))
  },
})

export default connect(null, mapDispatchToProps)(ConfirmEmailChange)
